// extracted by mini-css-extract-plugin
module.exports = {"styledRank":"abIk35yQ","styledIconRank":"oSrkYvOd","wrapper":"tcS328V_","styledPlaceholder":"PrGal4ZP"};